import { ExpenseHeader } from "@/components/Expense/ExpenseHeader";
import { ExpenseChartSection } from "@/components/ExpenseChart/ExpenseChartSection";
import { ListExpense } from "@/components/ListExpense/ListExpense";
import { OverviewFooter } from "@/components/Overview/OverviewFooter";
import { chartDateRangeAtom } from "@/store/global";
import { selectedCategoryOverviewFilterAtom } from "@/store/overview";
import { Outlet } from "@tanstack/react-router";
import { endOfDay, startOfDay, subDays } from "date-fns";
import { useAtom } from "jotai";
import { useEffect } from "react";

export const RecentTransactionPage = () => {
  const [, setSelectedCategory] = useAtom(selectedCategoryOverviewFilterAtom);
  const [, setChartDateRange] = useAtom(chartDateRangeAtom);

  useEffect(() => {
    setSelectedCategory(null);

    // set weekly date range to the current week on mount
    setChartDateRange({
      startDate: subDays(startOfDay(new Date()), 6),
      endDate: endOfDay(new Date()),
    });
  }, []);

  return (
    <>
      <ExpenseHeader />
      <ExpenseChartSection />
      {/* <ExpenseCategorySummary /> */}
      <div className="px-5 pt-7">
        <ListExpense />
      </div>

      {/* Nested layout for popups/dialogs */}
      <Outlet />
    </>
  );
};
